module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect-69abce10e42d37ba946087a59c947aa1.png";